import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, withCtx as _withCtx } from "vue"
import _imports_0 from '@/assets/icons/CloseModal.svg'


const _hoisted_1 = { class: "pickedUpReservation" }
const _hoisted_2 = { class: "pickedUpReservation__header" }
const _hoisted_3 = { class: "text" }
const _hoisted_4 = { class: "pickedUpReservation__buttons" }
const _hoisted_5 = {
  key: 0,
  class: "pickedUpReservation__verifySSN"
}
const _hoisted_6 = {
  key: 1,
  class: "pickedUpReservation__withAnotherSSN"
}
const _hoisted_7 = {
  key: 2,
  class: "pickedUpReservation__verify"
}
const _hoisted_8 = {
  key: 3,
  class: "error-verifySSN"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Button = _resolveComponent("Button")!
  const _component_Input = _resolveComponent("Input")!
  const _component_Checkbox = _resolveComponent("Checkbox")!
  const _component_Modal = _resolveComponent("Modal")!

  return (_ctx.showModalPickedUpReservation)
    ? (_openBlock(), _createBlock(_component_Modal, {
        key: 0,
        onClose: _ctx.closeAllModal
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, [
            _createElementVNode("div", _hoisted_2, [
              _createElementVNode("p", _hoisted_3, _toDisplayString(_ctx.$t('pickedUpRevervation')), 1),
              _createElementVNode("img", {
                src: _imports_0,
                alt: "CloseModal",
                onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.closeAllModal && _ctx.closeAllModal(...args)))
              })
            ]),
            _createElementVNode("div", _hoisted_4, [
              _createVNode(_component_Button, {
                variant: "filled",
                title: _ctx.$t('verifySSN'),
                onClick: _ctx.openVerifySSN
              }, null, 8, ["title", "onClick"]),
              _createVNode(_component_Button, {
                variant: "filled",
                title: _ctx.$t('pickupForAnotherSSN'),
                onClick: _ctx.openPickupForAnotherSSN
              }, null, 8, ["title", "onClick"]),
              (!_ctx.activeReservations.req_ph_ssn)
                ? (_openBlock(), _createBlock(_component_Button, {
                    key: 0,
                    variant: "filled",
                    title: _ctx.$t('verify'),
                    onClick: _ctx.openVerifyWithoutSSN
                  }, null, 8, ["title", "onClick"]))
                : _createCommentVNode("", true),
              _createVNode(_component_Button, {
                variant: "notBordered",
                title: _ctx.$t('no'),
                onClick: _ctx.closeAllModal
              }, null, 8, ["title", "onClick"])
            ]),
            (_ctx.isVerifySSN)
              ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.inputsVerifySSN, (el) => {
                    return (_openBlock(), _createBlock(_component_Input, {
                      key: el.value,
                      type: "text",
                      name: el.value,
                      modelValue: el.value,
                      "onUpdate:modelValue": ($event: any) => ((el.value) = $event),
                      forName: el.value,
                      label: el.label,
                      validation: el.validation,
                      validationMessages: {
            required: _ctx.$t('validation.required')
          },
                      onInput: _ctx.handleChange
                    }, null, 8, ["name", "modelValue", "onUpdate:modelValue", "forName", "label", "validation", "validationMessages", "onInput"]))
                  }), 128)),
                  _createVNode(_component_Button, {
                    variant: "filled",
                    title: _ctx.$t('verifySSN'),
                    onClick: _ctx.verifySSNRequest
                  }, null, 8, ["title", "onClick"])
                ]))
              : _createCommentVNode("", true),
            (_ctx.isPickUpWithAnotherSSN)
              ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.inputsSSN, (el) => {
                    return (_openBlock(), _createBlock(_component_Input, {
                      key: el.value,
                      type: "text",
                      name: el.value,
                      modelValue: el.value,
                      "onUpdate:modelValue": ($event: any) => ((el.value) = $event),
                      forName: el.value,
                      label: el.label,
                      validation: el.validation,
                      validationMessages: {
            required: _ctx.$t('validation.required')
          },
                      onChange: _ctx.handleChange
                    }, null, 8, ["name", "modelValue", "onUpdate:modelValue", "forName", "label", "validation", "validationMessages", "onChange"]))
                  }), 128)),
                  _createVNode(_component_Checkbox, {
                    name: "pickUpWithAnotherSSN",
                    value: _ctx.pickUpWithAnotherSSN,
                    title: _ctx.$t('pickUpWithAnotherSSN'),
                    onChange: _cache[1] || (_cache[1] = ($event: any) => (_ctx.pickUpWithAnotherSSN = !_ctx.pickUpWithAnotherSSN))
                  }, null, 8, ["value", "title"]),
                  _createVNode(_component_Button, {
                    variant: _ctx.pickUpWithAnotherSSN ? 'filled' : 'disabledBackground',
                    title: _ctx.$t('pickupForAnotherSSN'),
                    onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.pickUpWithAnotherSSN ? _ctx.checkFormData() : ''))
                  }, null, 8, ["variant", "title"])
                ]))
              : _createCommentVNode("", true),
            (_ctx.isOpenVerifyWithoutSSN)
              ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.inputsVerifyWithoutSSN, (el) => {
                    return (_openBlock(), _createBlock(_component_Input, {
                      key: el.value,
                      type: "text",
                      name: el.value,
                      modelValue: el.value,
                      "onUpdate:modelValue": ($event: any) => ((el.value) = $event),
                      forName: el.value,
                      label: el.label,
                      validation: el.validation,
                      validationMessages: {
            required: _ctx.$t('validation.required')
          },
                      onChange: _ctx.handleChange
                    }, null, 8, ["name", "modelValue", "onUpdate:modelValue", "forName", "label", "validation", "validationMessages", "onChange"]))
                  }), 128)),
                  _createVNode(_component_Checkbox, {
                    name: "pickUpWithAnotherSSN",
                    value: _ctx.pickUpWithAnotherSSN,
                    title: _ctx.$t('pickUpWithAnotherSSN'),
                    onChange: _cache[3] || (_cache[3] = ($event: any) => (_ctx.pickUpWithAnotherSSN = !_ctx.pickUpWithAnotherSSN))
                  }, null, 8, ["value", "title"]),
                  _createVNode(_component_Button, {
                    variant: _ctx.pickUpWithAnotherSSN ? 'filled' : 'disabledBackground',
                    title: _ctx.$t('verifyDeliveryWithoutSSN'),
                    onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.pickUpWithAnotherSSN ? _ctx.verifyDeliveryWithoutSSN() : ''))
                  }, null, 8, ["variant", "title"])
                ]))
              : _createCommentVNode("", true),
            (_ctx.isError && (_ctx.ssnVerify || _ctx.ssn))
              ? (_openBlock(), _createElementBlock("p", _hoisted_8, _toDisplayString(_ctx.$t('wrongSSN')), 1))
              : _createCommentVNode("", true)
          ])
        ]),
        _: 1
      }, 8, ["onClose"]))
    : _createCommentVNode("", true)
}